export default __webpack_public_path__ + "static/media/ticon2.57d42bbb.jpg";